__webpack_require__.p = "/ManipulaText/";